function Missions(){

    return(
        <div>
            <h1>Missions</h1>
            <ul>
                <li>Remise a niveau de la GMAO(gestion de la maintenance assisté par ordinateur)</li>
                <li>Développement d'un site en React js pour La STEP de la Baumette angers</li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
        </div>
    )
}
export default Missions